var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9782 10.1931C15.9086 10.2044 15.8383 10.2096 15.7678 10.2087H3.77466L4.03617 10.3303C4.29179 10.4513 4.52434 10.616 4.7234 10.8169L8.08659 14.1801C8.52952 14.6029 8.60395 15.2831 8.26296 15.7917C7.86609 16.3337 7.105 16.4514 6.56297 16.0545C6.51918 16.0224 6.47756 15.9875 6.43844 15.9498L0.35674 9.86813C-0.118546 9.39338 -0.118964 8.62324 0.355789 8.14796C0.356093 8.14765 0.356436 8.14731 0.35674 8.14701L6.43844 2.0653C6.91411 1.59097 7.68424 1.59203 8.15862 2.0677C8.19594 2.10514 8.2308 2.14497 8.26296 2.18694C8.60395 2.69556 8.52952 3.37576 8.08659 3.79859L4.72949 7.16785C4.55103 7.3465 4.34584 7.4963 4.12131 7.61182L3.75641 7.77602H15.7009C16.3222 7.75295 16.8674 8.18699 16.9841 8.79775C17.0917 9.46085 16.6413 10.0856 15.9782 10.1931Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowBlack);
export default __webpack_public_path__ + "static/media/back_arrow_black.08d166ba26bdaa246a140a8fd6fc4313.svg";
export { ForwardRef as ReactComponent };